// extracted by mini-css-extract-plugin
module.exports = {"desksHeader":"Sidebar_desksHeader__1ciCa","noDesksInfo":"Sidebar_noDesksInfo__2MgvR","moreDesksIcon":"Sidebar_moreDesksIcon__JkJ_E"};